
<p><em>Hier kan je de playlist van Radio Scorpio raadplegen.
  Kies een datum en een tijdstip:</em>
      <br />
  </p>
  

<div class="new-line-fields">

  <mat-form-field id="startDatum" class="example-form-field">
    <mat-label>Datum...</mat-label>
    <input matInput [matDatepicker]="startPicker" [(ngModel)]="playlistfilter.filterdate" name="startdatum"
      placeholder="DD/MM/YYYY">
    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
    <mat-datepicker #startPicker></mat-datepicker>
  </mat-form-field>



  <mat-form-field id="startTijd" class="example-form-field">
    <mat-label>Tijd...</mat-label>
    <mat-select [(ngModel)]="playlistfilter.filterhour" >
      <mat-option value="00:00">00:00</mat-option>
      <mat-option value="01:00">01:00</mat-option>
      <mat-option value="02:00">02:00</mat-option>
      <mat-option value="03:00">03:00</mat-option>
      <mat-option value="04:00">04:00</mat-option>
      <mat-option value="05:00">05:00</mat-option>
      <mat-option value="06:00">06:00</mat-option>
      <mat-option value="07:00">07:00</mat-option>
      <mat-option value="08:00">08:00</mat-option>
      <mat-option value="09:00">09:00</mat-option>
      <mat-option value="10:00">10:00</mat-option>
      <mat-option value="11:00">11:00</mat-option>
      <mat-option value="12:00">12:00</mat-option>
      <mat-option value="13:00">13:00</mat-option>
      <mat-option value="14:00">14:00</mat-option>
      <mat-option value="15:00">15:00</mat-option>
      <mat-option value="16:00">16:00</mat-option>
      <mat-option value="17:00">17:00</mat-option>
      <mat-option value="18:00">18:00</mat-option>
      <mat-option value="19:00">19:00</mat-option>
      <mat-option value="20:00">20:00</mat-option>
      <mat-option value="21:00">21:00</mat-option>
      <mat-option value="22:00">22:00</mat-option>
      <mat-option value="23:00">23:00</mat-option>
    </mat-select>
  </mat-form-field>


</div>





<div class="new-line-fields" *ngIf="playlist?.playlistheader">
<div class="playlist-header"> {{playlist.playlistheader[0].showname}} - {{ playlist.playlistheader[0].startClocknl }} {{ playlist.playlistheader[0].sep }}
  {{ playlist.playlistheader[0].endClocknl }}
</div>
</div>



<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">


  <!-- Image Column -->
  <ng-container matColumnDef="Image">
    <th mat-header-cell *matHeaderCellDef> ZZZ </th>
    <td mat-cell *matCellDef="let element"> <img [src]="element.imageurl" class="newplaylistimg" alt="Description" />
    </td>
  </ng-container>


  <!-- Play Column -->
  <ng-container matColumnDef="Play">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let element">
      <div *ngIf="element.previewurl">
        <a [href]="element.previewurl" title="preview track" target="_blank">
          <i class="material-icons">replay_30</i>
        </a>
      </div>
      <div *ngIf="!element.previewurl"></div>
    </td>
  </ng-container>



  <!-- Preview Column -->
  <ng-container matColumnDef="Preview">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let element">


      <div *ngIf="element.playurl">
        <a [href]="element.playurl" title="play track on spotify" target="_blank">
          <i class="material-icons">play_arrow</i>
        </a>
      </div>
      <div  *ngIf="!element.playurl"></div>

    </td>
  </ng-container>




  <!-- Name Column -->
  <ng-container matColumnDef="Song">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let element"> {{element.song}} </td>
  </ng-container>


  <!--tr mat-header-row *matHeaderRowDef="displayedColumns"></tr-->
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>